import { ShieldAlert, DatabaseZap, CircleDollarSign } from "lucide-react";
import { Reveal, SectionTag } from "@/components/primitives";
import { useLanguage } from "@/hooks/use-language";

const ICONS = [ShieldAlert, DatabaseZap, CircleDollarSign];

export const Problem = () => {
  const { t } = useLanguage();
  return (
    <section className="py-24 lg:py-32 border-b border-border" data-testid="problem-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <SectionTag index="01" label={t.problem.tag} />
          <h2 className="font-display font-bold tracking-tight text-4xl sm:text-5xl max-w-3xl">
            {t.problem.h2}
          </h2>
          <p className="mt-6 max-w-xl text-base md:text-lg text-muted-foreground">
            {t.problem.sub}
          </p>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-3 border border-border">
          {t.problem.cards.map((card, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={card.title} delay={i * 0.12} className={`${i > 0 ? "border-t md:border-t-0 md:border-l" : ""} border-border`}>
                <div className="group p-10 h-full hover:bg-secondary/60 transition-colors duration-500" data-testid={`problem-card-${i}`}>
                  <Icon size={28} strokeWidth={1.5} className="text-teal-600 dark:text-teal-400 group-hover:scale-110 transition-transform duration-500" />
                  <h3 className="mt-8 font-display font-bold text-lg">{card.title}</h3>
                  <p className="mt-4 text-sm leading-relaxed text-muted-foreground">{card.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
